import {Component, ElementRef, ChangeDetectionStrategy} from '@angular/core';

@Component({
  selector: 'app-element-loader',
  imports: [],
  templateUrl: './element-loader.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './element-loader.component.scss'
})
export class ElementLoaderComponent {
  constructor(private elementRef: ElementRef) {
  }

  setPosition(left: number, top: number): void {
    this.elementRef.nativeElement.style.left = left + 'px';
    this.elementRef.nativeElement.style.top = top + 'px';
  }

  setSize(width: number, height: number): void {
    this.elementRef.nativeElement.style.width = width + 'px';
    this.elementRef.nativeElement.style.height = height + 'px';
  }
}
